<ngx-spinner 
  bdColor="#fff" 
  size="large" 
  color="#06c" 
  type="triangle-skew-spin" 
  [fullScreen]="true">
  <p style="color: #06c">Caricamento</p>
</ngx-spinner>
